/***********************************************
* PhotoTool.js
* 
* Shows photos containing a point
***********************************************/
/* Layout files */
import '../assets/style/PhotoTool.css';

/* Global imports */
import React, { useState, useEffect, useCallback } from 'react';
import { withTranslation } from 'react-i18next';

/* Local imports */
import API from './API';
import { useAuthenticatedImage } from './useAuthenticatedImage';

const PhotoThumb = ({ projectId, imgId, selected, onSelect }) => {
    const src = '/media/thumb?project_id=' + projectId + '&image_id=' + imgId;
    const { url, loading, error } = useAuthenticatedImage(src);

    if (loading) return <div className="spinner">...</div>;
    if (error) return <div className="error-icon">⚠️</div>;
  
    return <img src={url} className={"photoImg " + (selected ? "selected" : "")} onClick={() => onSelect(imgId)} alt=""/>;  
};

const PhotoImage = ({ projectId, imgId, name, t }) => {
    const src = '/media/image?project_id=' + projectId + '&image_id=' + imgId;
    const { url, loading, error } = useAuthenticatedImage(src);
  
    if (loading) return <div><div className="spinner"></div></div>;
    if (error) return <div className="error-icon">⚠️</div>;
  
    return (
        <>
            <a className='button hugeButton smallerText' href={url} download={name + "_" + imgId + ".jpg"} target="_blank" rel="noopener noreferrer">{t("download")}</a>
            <img src={url} className="photoPreview" alt=""/>
        </>
    );
};

function PhotoTool(props) {
    const [photoList, setPhotoList] = useState([]);
    const [selectedPhoto, setSelectedPhoto] = useState(0);

    const handleSelect = useCallback((photoId) => {
        setSelectedPhoto(photoId);
    }, []);

    useEffect(() => {
        setSelectedPhoto(0);
    }, [props.id]);

    useEffect(() => {
        setSelectedPhoto(0);
        API.GetPhotoList(props.id, props.pickedPoint, (reply) => {setPhotoList(reply["visible"]);});
    }, [props.pickedPoint]);

    return (
        <div className='photoTool'>
            <div className='photoList'>
                {
                    photoList.map((photo) => {
                        return <PhotoThumb key={photo} projectId={props.id} imgId={photo} selected={selectedPhoto === photo} onSelect={handleSelect}/>
                    })
                }
            </div>
            <div className='photoView'>
                {(selectedPhoto === 0) ? 
                    <div className="photoPreview">Select a photo</div> : 
                    <PhotoImage key="image" projectId={props.id} imgId={selectedPhoto} name={props.name} t={props.t}/> 
                }
            </div>
        </div>
    );
}

export default withTranslation("Projects")(PhotoTool);